export default __webpack_public_path__ + "static/media/NotSupport.bfcca05b.svg";